import { Grid } from '@design-system';
import classNames from 'classnames';
import React, { Fragment } from 'react';
import SbEditable from 'storyblok-react';

import { useProducts } from '../../../hooks/useProducts';
import { ProductListStoryblok } from '../../../types/generated-storyblok';
import { shopifyAdminIdToGraphqlId } from '../../../utils/shopifyIds';
import ProductTile from '../../ProductTile';

type Props = {
  blok: ProductListStoryblok;
  className?: string;
  analytics?: Analytics;
};

const ProductList: React.FC<Props> = ({ analytics, blok, className }) => {
  const { products } = useProducts(getBlokProductIds(blok as ProductIds));

  return (
    <Grid className={classNames(className, 'gap-y-6')} columns={4}>
      {/* @ts-expect-error require storyblok-react upgrade */}
      <SbEditable content={blok}>
        {products.map((product: Product, i: number) => {
          return (
            <Fragment key={product.id}>
              <div key={`product-${i}`} className="relative">
                <ProductTile
                  analytics={
                    analytics && {
                      page: analytics.page,
                      context: analytics.context,
                      position: i,
                    }
                  }
                  product={product}
                />
              </div>
            </Fragment>
          );
        })}
      </SbEditable>
    </Grid>
  );
};

export default ProductList;

const getBlokProductIds = (blok: ProductIds) => {
  return blok.products.map((productId: ShopifyProductIdentifier) =>
    shopifyAdminIdToGraphqlId(productId.id),
  );
};
